import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomApLogo = (props: SvgIconProps): JSX.Element => (
    <SvgIcon {...props} viewBox="0 0 69.118695 79.9897778">
        <svg
            width="69.118695"
            height="79.9897778"
            viewBox="0 0 69.118695 79.9897778"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g stroke="none">
                <polyline
                    fill="#FF322E"
                    points="0 71.6506667 69.118695 71.6506667 69.118695 80.0031111 0.000666739823 80.0031111 0 71.6506667"
                />
                <polyline
                    fill="currentColor"
                    points="15.9095234 18.8546667 4.2911375 53.7011111 12.7031716 53.7011111 20.5947041 29.0704444 24.550027 41.3844444 19.4334656 41.3844444 17.3901303 48.4137778 26.8078303 48.4137778 28.5060166 53.7011111 37.1585216 53.7011111 25.5414691 18.8546667 15.9095234 18.8546667"
                />
                <path
                    d="M50.3773053,18.8546667 L38.2999801,18.8546667 L38.2999801,53.7011111 L46.6520077,53.7011111 L46.6520077,25.8842222 L50.017488,25.8842222 C53.9225832,25.8842222 56.4716164,27.5324444 56.4716164,31.3848889 C56.4716164,35.5253333 53.7627052,37.1022222 49.8576099,37.1022222 L48.1594236,37.1022222 L48.1594236,44.0604444 L49.8576099,44.0604444 C58.5887838,44.0604444 65.063513,40.7084444 65.063513,31.2435556 C65.063513,22.4213333 59.0280633,18.8546667 50.3773053,18.8546667"
                    fill="currentColor"
                />
            </g>
        </svg>
    </SvgIcon>
);
